
<div class="phrase-txt"  [class.itemChosen]="item.chosen == true">
    <!-- {{item.text}} -->
    <div *ngFor="let txt of getTextLines()">{{txt}}</div>
</div>